import { useEffect, useMemo} from "react"

declare global {
  interface Window {
    dataLayer?: {
      push: (data: TrackingData) => void
    }
  }
}

type BaseTrackingData = {}

interface ScreenTrackingData {
  event: "screen_view"
  screen_name: ScreenName
}

interface OpenRegularPackTrackingData {
  event: "open_standard_pack"
}

interface OpenPremiumPackTrackingData {
  event: "open_premium_pack"
}

interface CodeActivateTrackingData {
  event: "activate_code"
  code_type: "promo_code" | "single_code"
}

interface RedeemCodeOkTrackingData {
  event: "redeem_code_ok"
  redeem_code: string
}

interface RedeemCodeKoTrackingData {
  event: "redeem_code_ko"
}

type ScreenName = "/teaser_experience" // for now all events are tracked into a single screen

export type TrackingData = BaseTrackingData & SpecialTrackingData

type SpecialTrackingData = ScreenTrackingData
  | OpenRegularPackTrackingData
  | OpenPremiumPackTrackingData
  | CodeActivateTrackingData
  | RedeemCodeOkTrackingData
  | RedeemCodeKoTrackingData

const safeTrack = (data: TrackingData) => {
  try {
    if (window.dataLayer) {
      window.dataLayer.push(data)
    } else {
      console.warn("dataLayer is missing")
    }
  } catch (e) {
    console.error(e)
  }
}

export const useTracking = () => {
  return useMemo(() => ({
    track: (data: TrackingData) => {
      console.log("track:", data)
      safeTrack(data)
    }
  }), [])
}

export const useScreenTracking = (screenName: ScreenName) => {
  const { track } = useTracking()

  useEffect(() => {
    track({
      event: "screen_view",
      screen_name: screenName
    })
  }, [screenName])
}